import { useAgreementHistory, useAgreementNotes } from './queries'
import { Skeleton, Stack } from '@mui/material'
import dayjs from 'dayjs'
import { useMemo } from 'react'
import { AgreementHistoryNote } from './types'
import { AgreementNoteView } from './AgreementNoteView'

export const AgreementNotes = ({ agreementId }: { agreementId: string }) => {
  const notes = useAgreementNotes(agreementId)
  const history = useAgreementHistory(agreementId)

  const notesAndHistory: undefined | AgreementHistoryNote[] = useMemo(() => {
    return notes.data?.map(n => {
      const relatedHistory = history.data?.find(h => {
        return dayjs(h.modifiedDate).diff(dayjs(n.modifiedDate), 'millisecond') < 100
      })
      return { ...relatedHistory, ...n }
    })
  }, [notes.isFetched, history.isFetched])

  return notes.isLoading || history.isLoading ? (
    <Stack spacing={2}>
      {[0, 1, 2, 3].map(a => (
        <Skeleton key={a} variant="rectangular" width="100%" height="55px" />
      ))}
    </Stack>
  ) : (
    <Stack spacing={2}>
      {notesAndHistory?.map((n, index) => (
        <AgreementNoteView key={index} note={n} />
      ))}
    </Stack>
  )
}
